export default "__VITE_ASSET__BzIQyFdv__"